import { Record } from 'immutable';
import isEqual from 'hs-lodash/isEqual';
import getIn from 'immutable-less/transmute/getIn';
import setIn from 'immutable-less/transmute/setIn';
import * as InboundDbMetaTypeIds from 'automation-ui-references/object-types/InboundDbMetaTypeIds';
export class EventTypeId extends Record({
  metaType: InboundDbMetaTypeIds.HUBSPOT_EVENT,
  innerId: 0
}, 'EventTypeId') {
  constructor(props = {}) {
    const metaType = props.metaType;
    super(Object.assign({}, props, {
      // Convert the enum value to meta type number
      metaType: typeof metaType === 'string' ? InboundDbMetaTypeIds[metaType] : metaType
    }));
  }
}
export class EventFilterId extends Record({
  id: 0,
  version: 0
}, 'EventFilterId') {}
export class InnerEventFilter extends Record({
  eventTypeId: new EventTypeId(),
  objectTypeId: null,
  filter: null
}, 'InnerEventFilter') {
  constructor(props = {}) {
    super(Object.assign({}, props, {
      eventTypeId: new EventTypeId(props.eventTypeId)
    }));
  }
  setObjectTypeId(objectTypeId) {
    return this.set('objectTypeId', objectTypeId);
  }
  equals(innerEventFilter) {
    return this.eventTypeId.equals(innerEventFilter.eventTypeId) && isEqual(this.filter, innerEventFilter.filter);
  }
}
export default class EventFilter extends Record({
  eventFilterId: undefined,
  eventFilter: undefined,
  updateType: undefined
}, 'EventFilter') {
  constructor(props = {}) {
    super(Object.assign({}, props, {
      eventFilter: props.eventFilter ? new InnerEventFilter(props.eventFilter) : undefined,
      eventFilterId: props.eventFilterId ? new EventFilterId(props.eventFilterId) : undefined
    }));
  }
  getEventFilterId() {
    return this.eventFilterId;
  }
  getEventTypeId() {
    return getIn(['eventFilter', 'eventTypeId'], this);
  }
  getEventTypeInnerId() {
    return getIn(['eventFilter', 'eventTypeId', 'innerId'], this);
  }
  getEventTypeMetaType() {
    return getIn(['eventFilter', 'eventTypeId', 'metaType'], this);
  }
  getEventFilterEvent() {
    return getIn(['eventFilter', 'filter'], this);
  }
  getEventFilter() {
    return this.eventFilter;
  }
  getUpdateType() {
    return this.updateType;
  }
  setEventFilter(newInnerEventFilter) {
    const eventFilterId = this.getEventFilterId();
    const updateType = eventFilterId ? 'UPDATE' : 'CREATE';
    return this.set('eventFilter', newInnerEventFilter).set('updateType', updateType);
  }
  setEventFilterId(id) {
    return this.set('eventFilterId', id);
  }
  setEventTypeId(eventTypeId) {
    return setIn(['eventFilter', 'eventTypeId'], eventTypeId, this);
  }
  setUpdateType(type) {
    return this.set('updateType', type);
  }
  deleteEventFilter() {
    return this.set('eventFilter', null).set('updateType', 'DELETE');
  }
}